import { createAsyncActionType } from './index';

export const TOJ_CONTENT_GET = createAsyncActionType('toj', 'TOJ_CONTENT_GET');
export const TOJ_LIST_GET = createAsyncActionType('toj', 'TOJ_LIST_GET');
export const TOJ_SESSION_MODE = createAsyncActionType('toj', 'TOJ_SESSION_MODE');
export const TOJ_LIKE_DISLIKE = createAsyncActionType('toj', 'TOJ_LIKE_DISLIKE');
export const TOJ_SESSION_PLAN_SET = createAsyncActionType('toj', 'TOJ_SESSION_PLAN_SET');
